"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _params = require("hub-http/helpers/params");

var _object = require("../utils/object");

var _Account = _interopRequireDefault(require("hub-pickers-lib/Accounts/records/Account"));

var _Analytics = _interopRequireDefault(require("hub-pickers-lib/Accounts/records/Analytics"));

var _ProductTags = _interopRequireDefault(require("./ProductTags"));

var _links = require("../utils/links");

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIIconCircle = _interopRequireDefault(require("UIComponents/icon/UIIconCircle"));

var _UIChangeArrow = _interopRequireDefault(require("UIComponents/icon/icons/UIChangeArrow"));

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _UITableHoverCell = _interopRequireDefault(require("UIComponents/table/UITableHoverCell"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _RequestStatusTypes = _interopRequireDefault(require("hub-pickers-lib/constants/RequestStatusTypes"));

var HubPickerRow = (0, _createReactClass.default)({
  displayName: "HubPickerRow",
  propTypes: {
    account: _propTypes.default.instanceOf(_Account.default).isRequired,
    pinned: _propTypes.default.bool,
    onPinChange: _propTypes.default.func.isRequired,
    analytics: _propTypes.default.instanceOf(_Analytics.default),
    analyticsRequestStatus: _propTypes.default.string,
    shouldGetAnalytics: _propTypes.default.bool,
    redirectTo: _links.redirectLink.isRequired,
    query: _propTypes.default.object
  },
  getRedirectUrl: function getRedirectUrl() {
    var _this$props = this.props,
        redirectTo = _this$props.redirectTo,
        query = _this$props.query,
        id = _this$props.account.id;
    var redirectUrl = redirectTo(id);

    if (!(0, _object.isEmpty)(query)) {
      redirectUrl += "" + (redirectUrl.indexOf('?') === -1 ? '?' : '&') + (0, _params.stringify)(query);
    }

    return redirectUrl;
  },
  handleRowClick: function handleRowClick(e) {
    if (e.metaKey) {
      window.open(this.getRedirectUrl());
    } else {
      window.location = this.getRedirectUrl();
    }
  },
  onOpenButtonClick: function onOpenButtonClick(e) {
    window.open(this.getRedirectUrl());
    e.stopPropagation();
  },
  onPinButtonClick: function onPinButtonClick(e) {
    this.props.onPinChange(this.props.account.id);
    e.stopPropagation();
  },
  renderCurrentPeriodSessions: function renderCurrentPeriodSessions() {
    return _react.default.createElement("span", {
      className: "sessions-data"
    }, this.props.analytics.totals.currentPeriodSessions || '--');
  },
  renderCurrentPeriodLeads: function renderCurrentPeriodLeads() {
    return _react.default.createElement("span", {
      className: "sessions-data"
    }, this.props.analytics.totals.currentPeriodLeads || '--');
  },
  renderChangeInSessions: function renderChangeInSessions() {
    var changeInSessions = this.props.analytics.changeInSessions;

    if (changeInSessions === null) {
      return null;
    }

    var changeArrow = null;

    if (changeInSessions > 0) {
      changeArrow = _react.default.createElement(_UIChangeArrow.default, {
        size: 12,
        use: "increase"
      });
    } else if (changeInSessions < 0) {
      changeArrow = _react.default.createElement(_UIChangeArrow.default, {
        size: 12,
        use: "decrease"
      });
    }

    return _react.default.createElement("span", {
      className: "subtext"
    }, changeArrow, Math.abs(changeInSessions), "%");
  },
  renderChangeInLeads: function renderChangeInLeads() {
    var changeInLeads = this.props.analytics.changeInLeads;

    if (changeInLeads === null) {
      return null;
    }

    var changeArrow = null;

    if (changeInLeads > 0) {
      changeArrow = _react.default.createElement(_UIChangeArrow.default, {
        size: 12,
        use: "increase"
      });
    } else if (changeInLeads < 0) {
      changeArrow = _react.default.createElement(_UIChangeArrow.default, {
        size: 12,
        use: "decrease"
      });
    }

    return _react.default.createElement("span", {
      className: "subtext"
    }, changeArrow, Math.abs(changeInLeads), "%");
  },
  renderSessions: function renderSessions() {
    var _this$props2 = this.props,
        analytics = _this$props2.analytics,
        analyticsRequestStatus = _this$props2.analyticsRequestStatus,
        shouldGetAnalytics = _this$props2.shouldGetAnalytics;

    if (!shouldGetAnalytics) {
      return null;
    }

    if (!analytics || analyticsRequestStatus === _RequestStatusTypes.default.FAILED) {
      return _react.default.createElement("td", {
        className: "text-right"
      }, _react.default.createElement("span", {
        className: "sessions-data"
      }, "--"));
    }

    return _react.default.createElement("td", {
      className: "text-right"
    }, this.renderCurrentPeriodSessions(), this.renderChangeInSessions());
  },
  renderLeads: function renderLeads() {
    var _this$props3 = this.props,
        analytics = _this$props3.analytics,
        analyticsRequestStatus = _this$props3.analyticsRequestStatus,
        shouldGetAnalytics = _this$props3.shouldGetAnalytics;

    if (!shouldGetAnalytics) {
      return null;
    }

    if (!analytics || analyticsRequestStatus === _RequestStatusTypes.default.FAILED) {
      return _react.default.createElement("td", {
        className: "text-right"
      }, _react.default.createElement("span", {
        className: "sessions-data"
      }, "--"));
    }

    return _react.default.createElement("td", {
      className: "text-right"
    }, this.renderCurrentPeriodLeads(), this.renderChangeInLeads());
  },
  render: function render() {
    var _this$props4 = this.props,
        _this$props4$account = _this$props4.account,
        accountName = _this$props4$account.accountName,
        domain = _this$props4$account.domain,
        id = _this$props4$account.id,
        products = _this$props4$account.products,
        pinned = _this$props4.pinned;
    var accountNameOrId = accountName || id;
    return _react.default.createElement("tr", {
      onClick: this.handleRowClick,
      key: accountNameOrId
    }, _react.default.createElement(_UITableHoverCell.default, {
      hoverContent: _react.default.createElement("span", null, _react.default.createElement(_UIButton.default, {
        onClick: this.onPinButtonClick,
        size: "extra-small",
        use: "tertiary-light"
      }, pinned ? 'Unpin' : 'Pin'), _react.default.createElement(_UIButton.default, {
        onClick: this.onOpenButtonClick,
        size: "extra-small",
        use: "tertiary-light"
      }, "Open", _react.default.createElement(_UIIcon.default, {
        name: "externalLink",
        alignment: "middle"
      })))
    }, pinned && _react.default.createElement(_UIIconCircle.default, {
      color: colors.OLAF,
      backgroundColor: colors.SORBET,
      legacy: true,
      name: "pin"
    }), _react.default.createElement("a", {
      href: this.getRedirectUrl(),
      "data-selenium": "portal-link"
    }, _react.default.createElement(_UITruncateString.default, {
      className: pinned ? 'pinned' : ''
    }, accountNameOrId))), _react.default.createElement("td", {
      className: "domain"
    }, _react.default.createElement(_UITruncateString.default, null, domain), _react.default.createElement("span", {
      className: "subtext"
    }, id)), this.renderSessions(), this.renderLeads(), _react.default.createElement("td", null, _react.default.createElement(_ProductTags.default, {
      products: products
    })));
  }
});
var _default = HubPickerRow;
exports.default = _default;
module.exports = exports.default;